export default __webpack_public_path__ + "static/media/success-1.6d33e163.jpg";